// reducers/TransactionSettingReducer.js
import {
    TRANSACTION_SETTING_INITIATED,
    TRANSACTION_SETTING_LOADED,
    TRANSACTION_SETTING_FAILED,
    TRANSACTION_SETTING_SAVED,
} from "../actions/TransactionSettingAction";
  
const initialState = {
    loading: false,
    data: null,
    error: null,
};

const TransactionSettingReducer = (state = initialState, action) => {
    switch (action.type) {
        case TRANSACTION_SETTING_INITIATED:
        return { ...state, loading: true, error: null };

        case TRANSACTION_SETTING_LOADED:
        case TRANSACTION_SETTING_SAVED:
        return { ...state, loading: false, data: action.payload };

        case TRANSACTION_SETTING_FAILED:
        return { ...state, loading: false, error: action.payload };

        default:
        return state;
}
};

export default TransactionSettingReducer;